export default class {
  constructor (provider) {
    this.id = provider.id // id CLuxe du provider
    this.name = provider.name // nom du provider
    this.externalId = provider.externalId // id du camping chez le provider
    this.usePayzenShop = provider.usePayzenShop // utilise ou non la boutique payzen
  }
}
